(() => {
	angular.module('main').directive('btnUpdateCardDet', updateCardDetails);

	updateCardDetails.$inject = [
		'$rootScope',
		'accountService',
		'messageService',
		'randomStringGenerator',
		'stripeDataService',
		'stripeService'
	];

	function updateCardDetails(
		$rootScope,
		accountService,
		messageService,
		randomStringGenerator,
		stripeDataService,
		stripeService
	) {
		return {
			restrict: 'E',
			scope: {},
			template: `
                <section>
               
                    <button class="btn btn-success btn-lg mb-0"
                        ng-click="showUpdateCardDetModal()"
                        >Update billing details</button> 
                        
                    <div id="{{updateCardDetModalId}}" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog w-440">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <btn-close></btn-close>
                                        <h3 class="modal-title">Update billing details</h3>
                                    </div>
                                    <form name="creationForm" ng-submit="sendUpdatedCardDet(card)">
                                        <div class="modal-body">
                                            <div class="form-group mb-20">
                                                <label class="control-label f-s-14">Card Number</label>
                                                <input autocorrect="off"
                                                       autocapitalize="off"
                                                       autocomplete="off"
                                                       class="form-control card-number" 
                                                       maxlength="16"
                                                       ng-model="card.number"
                                                       placeholder="Enter the number without spaces or hyphens"
                                                       required
                                                       size="20" 
                                                       spellcheck="off"
                                                       type="text"
                                                 />
                                            </div>
                                            <div class="form-group mb-20">
                                                <label class="control-label f-s-14">Expiration (MM/YYYY)</label>
                                                <div class="form-inline">
                                                    <input class="form-group form-control card-expiry" maxlength="2"
                                                           placeholder="MM" size="2" type="text" required autocomplete="off"
                                                           ng-model="card.exp_month">
                                                    <input class="form-control card-expiry" type="text" size="4" autocomplete="off" required
                                                           placeholder="YYYY" ng-model="card.exp_year" maxlength="4">
                                                </div>
                                            </div>
                                            <div class="form-group mb--8">
                                                <label class="control-label f-s-14">CW code</label>
                                                <input type="text" class="form-control card-cvc" size="4" maxlength="4" required
                                                        autocomplete="off" placeholder="Enter CW number" ng-model="card.cvc">
                                            </div>
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button type="submit" class="btn btn-success btn-lg mb-0" ng-disabled="buttonDisable"
                                            spinning-wheel is-spinning-wheel-active="buttonDisable">Save details</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> 
                         
                </section>
                `,
			replace: true,
			transclude: true,

			link(scope) {
				const modalIndex = randomStringGenerator.getMixedString(9);
				const updateCardDetModalId = `updateCardDetModal-${modalIndex}`;

				scope.updateCardDetModalId = updateCardDetModalId;

				scope.showUpdateCardDetModal = () => {
					$(`#${updateCardDetModalId}`).modal('show');
				};

				scope.sendUpdatedCardDet = function() {
					scope.buttonDisable = true;

					if (isCardDetailsValid()) {
						stripeDataService
							.getStripeUserKey()
							.subscribe(
								data => sendCardToken(data),
								error => errorStripeCallback(error.data)
							);
					} else {
						scope.buttonDisable = false;
					}
				};

				const isCardDetailsValid = () => {
					const { number, exp_month, exp_year, cvc } = scope.card;
					const data = {
						ccNum: number,
						expMonth: exp_month,
						expYear: exp_year,
						cvcNum: cvc
					};
					return stripeService.isStripeCardValid(data);
				};

				const sendCardToken = data => {
					if (data && data.message) {
						$rootScope.stripePK = data.message;
						Stripe.setPublishableKey($rootScope.stripePK);
						Stripe.card.createToken(scope.card, stripeResponseHandler);
					} else {
						scope.errorStripeCallback(data);
					}
				};

				const stripeResponseHandler = (status, response) => {
					if (response.error) {
						scope.buttonDisable = false;
						messageService.showToaster(
							'e_2',
							'general',
							response.error.message
						);
					} else {
						scope.stripe_token = response.id;
						scope.buttonDisable = true;
						stripeTokenServerCall();
					}

					if (!scope.$$phase) {
						scope.$apply();
					}
				};

				const stripeTokenServerCall = () => {
					stripeDataService
						.updateCardDetails(scope.stripe_token)
						.subscribe(
							data => successUpdateCardDetails(),
							error => errorStripeCallback(error.data)
						);
				};

				const successUpdateCardDetails = () => {
					scope.buttonDisable = false;
					accountService.getUserWeb().subscribe(data => {
						if (data.enabled) {
							$rootScope.removeBg = 'blah';
						}
					});

					messageService.showToaster(
						's_0',
						'general',
						'Credit card details have been updated'
					);
					$(`#${updateCardDetModalId}`).modal('hide');
				};

				const errorStripeCallback = data => {
					scope.buttonDisable = false;
					switch (data.errorMessage) {
						case "Your card's security code is incorrect.":
							messageService.showToaster('e_2', 'stripe');
							break;
						case 'Your card was declined.':
							messageService.showToaster('e_4', 'stripe');
							break;
						case 'Your card has insufficient funds.':
							messageService.showToaster('e_5', 'stripe');
							break;
						case 'Your card has expired.':
							messageService.showToaster('e_6', 'stripe');
							break;
						case 'An error occurred while processing your card. Try again in a little bit.':
							messageService.showToaster('e_7', 'stripe');
							break;
						default:
							messageService.showToaster('e_0', 'general');
							break;
					}
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/Modals/btnUpdateCardDetails.js